<template>
    <div class="d-flex align-items-center">
        <responsive-button
            v-if="!isHidden && triggerType != AUTOMATED_PAYMENT_IDENTIFIER"
            :icon="['far', 'paper-plane']"
            variant="outline-primary"
            :title="isReSendButton ? 'Resend' : 'Send'"
            :responsiveness="false"
            size="sm"
            @click="showSendTrigger"
        >
            {{ isReSendButton ? 'Resend' : 'Send' }}
        </responsive-button>
        <modal :id="sendTriggerModalId" title="Send Trigger" @ok="sendTrigger">
            <busy-modal :show="loading"></busy-modal>
            <p>
                Are you sure you want to manually send this trigger now? Trigger
                will still be sent automatically if criteria applies.
            </p>
        </modal>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import API from '../../../../../api.jsx';
import Modal from '../../../../generic/modal/modal.vue';
import BusyModal from '../../../../generic/busy-modal/busy-modal.vue';
import ResponsiveButton from '../../../../generic/responsive-button/responsive-button.vue';
import { formatResponseError } from '../../../../../utils/api';
import { GUEST_TRIGGER_SEND_ENDPOINT } from '../../../../../endpoints.js';
import { AUTOMATED_PAYMENT_IDENTIFIER } from '../../../../trigger/trigger-edit/helpers/constants.js';

export default {
    components: { Modal, BusyModal, ResponsiveButton },
    data() {
        return {
            loading: false,
            sendTriggerModalId: null,
            triggerType: null,
            AUTOMATED_PAYMENT_IDENTIFIER: AUTOMATED_PAYMENT_IDENTIFIER,
        };
    },
    inject: ['showSuccessToast', 'showErrorToast'],
    created() {
        this.sendTriggerModalId = `send-trigger-modal-id-${this.params.data.id}`;
        this.triggerType = this.params.data.trigger_type;
    },
    computed: {
        ...mapGetters('guest', ['metadata', 'reservation']),
        isHidden() {
            return !this.params.data?.id_tech_reservation;
        },
        reservationEdit() {
            return this.metadata?.permissions?.reservation_edit;
        },
        isReSendButton() {
            return this.params.data?.timestamps?.length > 0;
        },
    },
    methods: {
        showSendTrigger() {
            this.$bvModal.show(this.sendTriggerModalId);
        },
        async sendTrigger() {
            this.loading = true;
            try {
                await API.post(
                    GUEST_TRIGGER_SEND_ENDPOINT(
                        this.reservation.user.id,
                        this.reservation.id,
                        this.params.data.id_trigger,
                    ),
                    { tech_reservation: this.params.data.id_tech_reservation }
                );
                this.showSuccessToast({ text: 'Trigger successfully queued.' });
            } catch (err) {
                const { generic } = formatResponseError(err);
                this.showErrorToast({
                    text: generic || 'Could not add trigger to queue.',
                });
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
:deep(.btn:focus) {
    box-shadow: none !important;
}
</style>
